// Widget width breakpoints, denoted in px
export enum WIDGET_BREAKPOINTS {
  EXTRA_WIDE = 440,
  WIDE = 420,
  MEDIUM = 400,
  SMALL = 375,
  EXTRA_SMALL = 350,
}
// Screen width breakpoints, denoted in px
export enum SCREEN_BREAKPOINTS {
  MOBILE = 900,
}
